import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

// Layouts
import App from './App';

// Pages
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';

// Tools
import Compressor from './tools/Compressor/Compressor';
import Resizer from './tools/Resizer/Resizer';
import Cropper from './tools/Cropper/Cropper';
import Converter from './tools/Converter/Converter';
import Editor from './tools/Editor/Editor';
import Rotator from './tools/Rotator/Rotator';
import Watermark from './tools/Watermark/Watermark';
import Html2Image from './tools/Html2Image/Html2Image';

const AppRouter = () => {
  return (
    <BrowserRouter basename="/SnapTools">
      <Routes>
        <Route path="/" element={<App />}>
          <Route index element={<HomePage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="privacy" element={<PrivacyPage />} />
          <Route path="terms" element={<TermsPage />} />
          
          {/* Tool Routes */}
          <Route path="tools/compressor" element={<Compressor />} />
          <Route path="tools/resizer" element={<Resizer />} />
          <Route path="tools/cropper" element={<Cropper />} />
          <Route path="tools/converter" element={<Converter />} />
          <Route path="tools/editor" element={<Editor />} />
          <Route path="tools/rotator" element={<Rotator />} />
          <Route path="tools/watermark" element={<Watermark />} />
          <Route path="tools/html2image" element={<Html2Image />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter; 